import {
  ArrowLeftOutlined,
  BugOutlined,
  ControlOutlined,
  DashboardOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  FilterOutlined,
  GlobalOutlined,
  LinkOutlined,
  MobileOutlined,
  SafetyOutlined,
  SettingOutlined,
  ThunderboltOutlined,
  TranslationOutlined,
} from '@ant-design/icons';
import { history, useParams } from '@umijs/max';
import { Menu } from 'antd';
import React from 'react';
import { useCloakRoutes } from '@/modules/cloak/context/CloakRouteContext';

const menuGroups = [
  {
    type: 'group' as const,
    label: '基本配置',
    children: [
      {
        key: 'overview',
        icon: <DashboardOutlined />,
        label: '概览',
      },
      {
        key: 'domains',
        icon: <GlobalOutlined />,
        label: '域名管理',
      },
      {
        key: 'basic',
        icon: <SettingOutlined />,
        label: '基础设置',
      },
      {
        key: 'visit-limit',
        icon: <ControlOutlined />,
        label: '访问限制',
      },
      {
        key: 'jump',
        icon: <LinkOutlined />,
        label: '跳转配置',
      },
    ],
  },
  {
    type: 'group' as const,
    label: '防护规则',
    children: [
      {
        key: 'urls',
        icon: <LinkOutlined />,
        label: '网址规则',
      },
      {
        key: 'ips',
        icon: <FilterOutlined />,
        label: '黑白名单',
      },
      {
        key: 'bots',
        icon: <BugOutlined />,
        label: '爬虫防护',
      },
      {
        key: 'security',
        icon: <SafetyOutlined />,
        label: '安全策略',
      },
      {
        key: 'geo',
        icon: <EnvironmentOutlined />,
        label: '国家地区',
      },
      {
        key: 'devices',
        icon: <MobileOutlined />,
        label: '设备过滤',
      },
      {
        key: 'language',
        icon: <TranslationOutlined />,
        label: '语言过滤',
      },
      {
        key: 'advanced',
        icon: <ThunderboltOutlined />,
        label: '高级设置',
      },
      {
        key: 'feature-switches',
        icon: <ControlOutlined />,
        label: '子功能开关',
      },
      {
        key: 'custom-params',
        icon: <ControlOutlined />,
        label: '自定义参数',
      },
    ],
  },
  {
    type: 'group' as const,
    label: '监控',
    children: [
      {
        key: 'logs',
        icon: <FileTextOutlined />,
        label: '访问日志',
      },
    ],
  },
];

const SiteSideMenu: React.FC = () => {
  const { siteId, feature } = useParams<{ siteId: string; feature?: string }>();
  const routes = useCloakRoutes();
  const activeTab = feature || 'overview';
  const siteBasePath = `${routes.sites}/${siteId}`;

  return (
    <Menu
      mode="inline"
      selectedKeys={[activeTab]}
      style={{ borderRight: 0 }}
      onClick={({ key }) => {
        if (key === '__back__') {
          history.push(routes.sites);
        } else {
          history.push(`${siteBasePath}/${key}`);
        }
      }}
      items={[
        {
          key: '__back__',
          icon: <ArrowLeftOutlined />,
          label: '返回站点列表',
        },
        { type: 'divider' },
        ...menuGroups,
      ]}
    />
  );
};

export default SiteSideMenu;
